import { Component, OnInit } from '@angular/core';
import { Course } from "../../courses/shared/course";
import { APPCONFIG } from "../../config";
import { ObjectObservable } from "../../shared/base/object-observable";
import { CourseService } from "../../courses/shared/course.service";
import { UserService } from "../../users/shared/user.service";
import { ActivatedRoute, Router} from "@angular/router";
import { Syllabus} from "../shared/syllabus";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material";
import { MESSAGE_COMMON_ERROR } from "../../shared/message";

@Component({
  selector: 'app-syllabus-detail',
  templateUrl: './syllabus-detail.component.html',
  styleUrls: ['./syllabus-detail.component.scss']
})
export class SyllabusDetailComponent implements OnInit {

  course: Course;
  courseObservable: ObjectObservable<Course>;
  AppConfig: any;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.route.data.subscribe((data: { course: ObjectObservable<Course> }) => {
      this.courseObservable = data.course;
      data.course.subscribe(course => {
        this.course = course;
        if(this.course.syllabus) {
          this.course.ownerObservable = this.userService.readChild(this.course.owner);
        }
      })
    });
  }

  async createSyllabus() {
    try {
      const syllabus = Object.assign(new Syllabus(), {
        owner: this.course.owner
      });
      console.log(syllabus);
      this.course.syllabus = syllabus;
      await this.courseObservable.update(this.course);
    } catch (e) {
      console.log(e);
      this.handleError(e);
    }
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }
}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-detail/syllabus-detail.component.ts